import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import {Root} from './ToolEstate.css';
import PageTitle from '../Layout/components/PageTitle';
import {
    Button,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Dialog,
    Breadcrumbs,
    Link,
    Typography,
    TableFooter,
    TablePagination,
    Snackbar,
    InputBase,
    DialogContent,
    DialogContentText,
    CircularProgress,
    withStyles,
    LinearProgress,
    Menu,
    MenuItem
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import {BASE_URL} from '../../store/config';
import instance from '../../request/http';
import {
    roleStr,
    globalData,
    defaultPageSize,
    ADD,
    EDIT,
    CLIENT,
    SPOUSE,
    MANUAL,
    EMAIL,
    DRAFT,
    FINAL
} from '../../common/common';
import {timeFormatS, timeFormat, clone, newId} from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'
import EstateInfo from './components/normal/EstateInfo';
import EstateInfoSingle from './components/single/EstateInfo';
import UploadView from './components/UploadView';
import Alert from '@material-ui/lab/Alert';
import axios from 'axios';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 10,
        borderRadius: 5,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
    bar: {
        borderRadius: 5,
        backgroundColor: "#1a90ff",
    },
}))(LinearProgress);

class ToolEstate extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            crtEpId: "",
            open: false,
            openSingle: false,
            openUpload: false,
            openProgress: false,
            dialogTitle: "CREATE / EDIT DOCUMENT",
            dialogState: ADD,
            dialogData: null,
            dialogTitleSingle: "CREATE / EDIT DOCUMENT",
            dialogStateSingle: ADD,
            dialogDataSingle: null,
            estateData: [],
            estateDataClone: [],
            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
            document: "",
            anchorEl: null,
            openMenu: false,

            showToast: false,
            toastMsg: "",
            toastState: "success",
            toastTitle: "",
            showAlert: false,
            showReplace: false,
            showAlertDownload: false,
            showAlertFile: false,
            dialogContent: "",
            toastTime: 3000,
            progress: 0,
            isUpload: false,
        }
        this.handleAddEstate = this.handleAddEstate.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleReplaceYes = this.handleReplaceYes.bind(this);
        this.handleAlertYesDownload = this.handleAlertYesDownload.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.handleSaveChange = this.handleSaveChange.bind(this);
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.handleSigned = this.handleSigned.bind(this);
        this.handleCloseMenu = this.handleCloseMenu.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.handleSingleFiles = this.handleSingleFiles.bind(this);
        this.handleCreateSingle = this.handleCreateSingle.bind(this);
        this.handleSendEmail = this.handleSendEmail.bind(this);
        this.handleManual = this.handleManual.bind(this);
    }

    render() {
        const {
            open,
            openUpload,
            openProgress,
            openMenu,
            openSingle,
            anchorEl,
            progress,
            estateData,
            dialogTitle,
            dialogState,
            dialogData,
            dialogTitleSingle,
            dialogStateSingle,
            dialogDataSingle,
            page_index,
            page_size,
            total_items,
            showToast,
            toastTitle,
            toastState,
            showAlert,
            showReplace,
            showAlertDownload,
            showAlertFile,
            dialogContent,
            toastTime,
            isUpload,
        } = this.state;
        const statusView = (status) => {
            if (status === "final") {
                return <div className="basic-status color-final c">Final</div>
            } else if (status === "draft") {
                return <div className="basic-status color-draft c">Draft</div>
            } else if (status === EMAIL) {
                return <div className="basic-status color-email c">Email Editing</div>
            } else if (status === MANUAL) {
                return <div className="basic-status color-manual c">Manual Editing</div>
            } else {
                return <div>--</div>
            }
        }
        const editView = (row) => {
            if (row.status === DRAFT || row.status === MANUAL || row.status === EMAIL) {
                return <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
            }
        }
        const signingView = (row) => {
            if (row.status === FINAL) {
                return <Button variant="outlined" color="primary" onClick={e => this.handleSigned(e, row)}>Signing
                    Date</Button>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/smarttools">All Smart Tools</Link>
                            <Typography className="crtTitle">Estate-Planning Files Generator Document List</Typography>
                        </Breadcrumbs>
                    </div>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleAddEstate}>CREATE
                            ESTATE-PLANNING DOCUMENT</Button>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            style={{marginTop: '50px', width: '316px'}}
                            open={openMenu}
                            onClose={this.handleCloseMenu}
                        >
                            <MenuItem onClick={this.handleFiles}>Case Type: Married with Children</MenuItem>
                            <MenuItem onClick={this.handleSingleFiles}>Case Type: Single with Children</MenuItem>
                        </Menu>
                    </div>
                </div>
                <div className="tableTool h">
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search/>
                        </div>
                        <InputBase
                            placeholder="Search by document name"
                            className="bgW"
                            inputProps={{"aria-label": "Search"}}
                            onChange={e => this.handleSearch(e, "caseNumber")}
                        />
                    </div>
                </div>
                <Paper className="tableWapper h">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Document Name</TableCell>
                                <TableCell>Note</TableCell>
                                <TableCell>Create Time</TableCell>
                                <TableCell>Modified Time</TableCell>
                                <TableCell>Signing Date</TableCell>
                                <TableCell>Current Status</TableCell>
                                <TableCell style={{minWidth: '466px'}}>Operations</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {estateData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell>{row.notes}</TableCell>
                                    <TableCell>{timeFormatS(row.create_time)}</TableCell>
                                    <TableCell>{timeFormatS(row.update_time)}</TableCell>
                                    <TableCell>{row.signed_date ? timeFormat(row.signed_date) : "--"}</TableCell>
                                    <TableCell>
                                        {statusView(row.status)}
                                    </TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            {editView(row)}
                                            <Button variant="outlined" color="primary"
                                                    onClick={e => this.handleDownload(e, row)}>Download</Button>
                                            <Button variant="outlined" color="primary"
                                                    onClick={e => this.handleUpload(e, row)}>upload final
                                                document</Button>
                                            {signingView(row)}
                                            <DeleteForeverIcon className="del"
                                                               onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {estateData.length === 0 && (
                                <TableRow style={{height: 300}}>
                                    <TableCell colSpan={12}/>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={estateData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: {"arialabel": "Rows per page"},
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Snackbar anchorOrigin={{vertical: "top", horizontal: "center"}} open={showToast}
                          autoHideDuration={toastTime} onClose={this.handleClose}>
                    <Alert severity={toastState}>
                        {toastTitle}
                    </Alert>
                </Snackbar>
                <Dialog maxWidth={false} open={open}>
                    <EstateInfo
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                        epStatus={dialogData ? dialogData.status : ""}
                        handleCreate={this.handleCreate}
                        handleSendEmail={this.handleSendEmail}
                        handleManual={this.handleManual}
                        handleCancel={this.handleCancel}
                    ></EstateInfo>
                </Dialog>
                <Dialog maxWidth={false} open={openSingle}>
                    <EstateInfoSingle
                        title={dialogTitleSingle}
                        data={dialogDataSingle}
                        state={dialogStateSingle}
                        handleCreate={this.handleCreateSingle}
                        handleCancel={this.handleCancel}
                    ></EstateInfoSingle>
                </Dialog>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this estate?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
                <AlertDialog
                    open={showReplace}
                    title="Warning"
                    content="You already had uploaded the final version, do you want to replace with a new final document?"
                    handleAlertYes={this.handleReplaceYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
                <AlertDialog
                    open={showAlertDownload}
                    title="Warning"
                    content="Would you like to download all the files now?"
                    handleAlertYes={this.handleAlertYesDownload}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
                <Dialog
                    open={showAlertFile}
                    // open={true}
                    onClose={this.handleAlertNo}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <DialogTitle id="alert-dialog-title">Prompt</DialogTitle> */}
                    <DialogContent className="c">
                        <CircularProgress style={{marginBottom: "20px"}}/>
                        <DialogContentText id="alert-dialog-description">
                            {dialogContent}
                            {/* The file is being generated and will be automatically downloaded after the generation is completed. The entire process is expected to take about 10 seconds, please be patient... */}
                        </DialogContentText>
                        {/* <LinearProgress /> */}
                    </DialogContent>
                    {/* <DialogActions>
                        <Button onClick={this.handleAlertNo} color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions> */}
                </Dialog>
                <Dialog maxWidth={false} open={openUpload} onClose={this.handleCancel}>
                    <UploadView
                        data={dialogData}
                        isUpload={isUpload}
                        handleUploadFile={this.handleUploadFile}
                        handleSaveChange={this.handleSaveChange}
                    />
                </Dialog>
                <Dialog maxWidth={false} open={openProgress}>
                    <div style={{width: '800px', padding: '40px'}}>
                        <div className="c"
                             style={{marginBottom: '40px', color: '#0060A0', fontWeight: 'bold', fontSize: '16px'}}>
                            Uploading, please wait…
                        </div>
                        <BorderLinearProgress variant="determinate" value={progress}/>
                        <div className="bgW h h-r">
                            <div>{progress}%</div>
                        </div>
                    </div>
                </Dialog>
            </Root>
        );
    }

    handleClose() {
        this.setState(() => ({
            showToast: false
        }))
    };

    componentDidMount() {
        this.getEstates();
    }

    getEstates(id = null, callback = null) {
        const {page_index, page_size, document} = this.state;
        let params = {
            name: document ? document : null,
            page_index,
            page_size
        }
        this.getEstate(params, (estateData) => {
            if (callback) {
                let epObj = {};
                for (const obj of estateData) {
                    if (obj.id === id) {
                        epObj = obj;
                    }
                }
                callback(epObj);
            }
        });
    }

    handleAddEstate(e) {
        const value = e.currentTarget;
        this.setState(() => ({
            anchorEl: value,
            openMenu: true
        }));
        // this.setState(() => ({
        //     dialogData: null,
        //     openMenu: false
        // }))
        // this.openDialog("CREATE / EDIT DOCUMENT", ADD);
    }

    handleFiles() {
        this.setState(() => ({
            dialogData: null,
            openMenu: false
        }))
        this.openDialog("CREATE / EDIT DOCUMENT", ADD);
    }

    handleSingleFiles(e) {
        this.setState(() => ({
            dialogDataSingle: null,
            openMenu: false
        }))
        this.openDialogSingle("CREATE / EDIT DOCUMENT", ADD);
    }

    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getEstates();
        })
    }

    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getEstates();
        });
    }

    handleSearch(e, name) {
        const value = e.target.value;
        this.setState({
            document: value,
            page_index: 1
        }, () => {
            this.getEstates();
        })
    }

    handleEdit(e, obj) {
        let estateDataClone = clone(this.state.estateData);
        console.log(obj)
        if (!obj.type || obj.type === "couple") {
            this.addSpouse(obj.content);
            this.setState(() => ({
                dialogData: obj,
                crtEpId: obj.id,
                estateDataClone,
            }))
            this.openDialog("EDIT DOCUMENT", EDIT);
        } else if (obj.type === "single") {
            this.setState(() => ({
                dialogDataSingle: obj,
                crtEpId: obj.id,
                estateDataClone,
            }))
            this.openDialogSingle("EDIT DOCUMENT", EDIT);
        }
    }

    handleDownload(e, obj) {
        this.setState(() => ({
            showAlertDownload: true,
            dialogData: obj
        }))
    }

    handleUpload(e, obj) {
        if (obj.status === "final") {
            this.setState(() => ({
                dialogData: obj,
                showReplace: true,
                isUpload: true
            }))
        } else {
            this.setState(() => ({
                dialogData: obj,
                openUpload: true,
                isUpload: true
            }))
        }
    }

    handleCreate(obj, isDraft) {
        const {dialogData, dialogState, crtEpId} = this.state;
        if (dialogState === ADD) {
            this.addEstate(obj, "couple");
        } else if (dialogState === EDIT) {
            this.updateEstate(dialogData.id, obj, "couple");
        }
        if (isDraft) {
            this.updateEstateStatus(crtEpId, DRAFT);
        }
    }

    handleSendEmail(obj) {
        const {crtEpId} = this.state;
        this.updateEstate(crtEpId, obj, "couple", true);
    }

    handleManual() {
        const {crtEpId} = this.state;
        this.updateEstateStatus(crtEpId, MANUAL);
    }

    handleCreateSingle(obj) {
        const {dialogDataSingle, dialogStateSingle} = this.state;
        if (dialogStateSingle === ADD) {
            this.addEstate(obj, "single");
        } else if (dialogStateSingle === EDIT) {
            this.updateEstate(dialogDataSingle.id, obj, "single");
        }
    }

    handleDel(e, obj) {
        this.setState(() => ({
            showAlert: true,
            dialogData: obj
        }));
    }

    handleUploadFile(date, file) {
        this.setState(() => ({
            openProgress: true,
            openUpload: false
        }));
        if (date) {
            const dos = (Date.parse(date) / 1000).toString();
            this.uploadFile(file, dos);
        }
    }

    handleSaveChange(date) {
        this.setState(() => ({
            openUpload: false
        }));
        if (date) {
            const dos = (Date.parse(date) / 1000).toString();
            this.updateEstateDOS(dos, () => {
                this.getEstates();
            });
        }
    }

    handleSigned(e, obj) {
        this.setState(() => ({
            dialogData: obj,
            openUpload: true,
            isUpload: false
        }))
    }

    handleAlertYes() {
        const {dialogData} = this.state;
        this.delEstate(dialogData.id);
        this.setState(() => ({
            showAlert: false
        }));
    }

    handleReplaceYes() {
        this.setState(() => ({
            openUpload: true,
            showReplace: false
        }));
    }

    handleAlertYesDownload() {
        const {dialogData} = this.state;
        console.log("final_urlfinal_urlfinal_urlfinal_urlfinal_url", dialogData.final_url)
        if (dialogData.status === "draft" && dialogData.draft_url) {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Ready to download...",
                showAlertDownload: false,
            }))
            this.downloadFile(dialogData.draft_url);
        } else if (dialogData.status === "final" && dialogData.final_url) {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Ready to download...",
                showAlertDownload: false,
            }))
            this.downloadFile(dialogData.final_url);
        } else {
            this.download(dialogData.id, dialogData.status);
            this.setState(() => ({
                showAlertDownload: false,
            }));
        }
    }

    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            showAlertDownload: false,
            showAlertFile: false,
            showReplace: false,
        }));
    }

    handleCancel() {
        const {dialogState} = this.state;
        if (dialogState !== ADD) {
            this.getEstates();
            // const estateData = this.state.estateDataClone;
            // this.setState(() => ({
            //     estateData
            // }))
        }
        this.closeDialog();
    }

    handleCloseMenu() {
        this.setState(() => ({
            openMenu: false
        }));
    }

    addSpouse(contentObj) {
        if (Object.keys(contentObj).length === 0) return;
        const spouseObj = this.extractSpouse(contentObj["INFO"]);
        const spouseCObj = this.extractSpouseC(contentObj["INFO"]);
        for (const key in contentObj) {
            if (contentObj.hasOwnProperty(key)) {
                const element = contentObj[key];
                if (this.addSpouseKey(key)) {
                    element.splice(0, 0, spouseObj);
                } else if (this.addSpouseCKey(key)) {
                    element.splice(0, 0, spouseCObj);
                }
            }
        }
    }

    extractSpouse(infoData) {
        const spouseInfo = {};
        // spouseInfo["id"] = "2";
        spouseInfo["type"] = SPOUSE;
        spouseInfo[".CHO.Em."] = infoData["S.Em"];
        spouseInfo[".CHO.N."] = infoData["S.F.Name"];
        spouseInfo[".CHO.AddrNPho"] = infoData["S.H.Addr."];
        spouseInfo[".CHO.Addr"] = infoData["S.H.Addr."];
        spouseInfo["S.H.Pho"] = infoData["S.H.Pho"];
        spouseInfo["S.W.Pho"] = infoData["S.W.Pho"];
        spouseInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
        spouseInfo["rc"] = "Client's";
        spouseInfo["relation"] = (infoData["P.SEX"] === "male") ? "Wife" : "Husband";
        globalData.spouseInfo = spouseInfo;
        return spouseInfo;
    }

    extractSpouseC(infoData) {
        if (!infoData) return;
        const clientInfo = {};
        // clientInfo["id"] = "1";
        clientInfo["type"] = CLIENT;
        clientInfo[".CHO.Em."] = infoData["P.Em"];
        clientInfo[".CHO.N."] = infoData["P.F.Name"];
        clientInfo[".CHO.AddrNPho"] = infoData["P.H.Addr."];
        clientInfo[".CHO.Addr"] = infoData["P.H.Addr."];
        clientInfo["P.H.Pho"] = infoData["P.H.Pho"];
        clientInfo["P.W.Pho"] = infoData["P.W.Pho"];
        clientInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        clientInfo["rc"] = "Spouse's";
        clientInfo["relation"] = (infoData["P.SEX"] === "male") ? "Husband" : "Wife";
        globalData.clientInfo = clientInfo;
        return clientInfo;
    }

    addSpouseKey(key) {
        if (key === "Ex") {//3 c
            return false;
        } else if (key === "Gu") {//4
            return true;
        } else if (key === "POA") {//5
            return false;
        } else if (key === "C.W.S.P.R") {//8
            return false;
        } else if (key === "C.F.S.P.R") {//9 c
            return false;
        } else if (key === "TRUSTEE") {//19
            return false;
        } else {
            return false;
        }
    }

    addSpouseCKey(key) {
        if (key === "S.Ex") {//11 s
            return false;
        } else if (key === "S.Gu") {//12
            return true;
        } else if (key === "S.POA") {//13
            return false;
        } else if (key === "S.W.S.P.R") {//16
            return false;
        } else if (key === "S.F.S.P.R") {//17 s
            return false;
        } else {
            return false;
        }
    }

    closeDialog() {
        this.setState(() => ({
            open: false,
            openSingle: false,
            openUpload: false,
            openProgress: false,
            crtMatterObj: null,
            dialogData: null,
        }));
    }

    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }

    openDialogSingle(title, state) {
        this.setState(() => ({
            openSingle: true,
            dialogTitleSingle: title,
            dialogStateSingle: state
        }));
    }

    //---------------request---------------
    sendEmail(id) {
        const params = {
            subject: "Questionnaire invitation from MT LAW",
            estate_planning_id: id,
        }
        instance.post(BASE_URL + "tool/send/email", params).then((res) => {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Email has been sent to the customer"
            }))
            this.updateEstateStatus(id, EMAIL);
        }).catch((err) => {
        })
    }

    putEstateEnable(code, enable) {
        const params = {
            enable,
        }
        instance.put(BASE_URL + `tool/estate/planning/code/${code}`, params).then((res) => {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "The form data has been submitted"
            }))
        })
    }

    getEPInfo(id, callback = null) {
        instance.get(BASE_URL + "tool/estate/planning/" + id).then((res) => {
            const data = res.data.data;
            console.log(data);
            if (callback) callback(data);
        })
    }

    epPolling(id, callback) {
        instance.get(BASE_URL + "tool/estate/planning/" + id + "/polling").then((res) => {
            let data = res.data.data;
            callback(data);
        })
    }

    getEstate(params, callback = null) {
        instance.get(BASE_URL + `tool/${roleStr()}/estate/planning`, {params}).then((res) => {
            console.log(res.data.data)
            const estateData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            this.setState({
                estateData,
                page_size,
                total_items,
            }, () => {
                if (callback) callback(estateData);
            })
        })
    }

    addEstate(obj, type) {
        const params = {
            email: obj.email,
            first_name: obj.first_name,
            last_name: obj.last_name,
            name: obj.name,
            notes: obj.note,
            content: obj.content,
            type
        }

        if (type === "single") {
            instance.post(BASE_URL + "tool/estate/planning", params).then((res) => {
                const id = res.data.data.id;
                this.updateEstateStatus(id, DRAFT);
                this.closeDialog();
            }).catch((err) => {
            })
            return;
        }
        instance.post(BASE_URL + "tool/estate/planning", params).then((res) => {
            const id = res.data.data.id;
            this.setState({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Added successfully",
                crtEpId: id,
            })
            this.getEstates(id, (dialogData) => {
                let estateDataClone = clone(this.state.estateData);
                this.setState({
                    dialogTitle: "EDIT DOCUMENT",
                    dialogState: EDIT,
                    dialogData,
                    estateDataClone
                })
            });
            // this.closeDialog();
        }).catch((err) => {
        })
    }

    updateEstateStatus(id, status) {
        const params = {
            status
        }
        instance.put(BASE_URL + "tool/estate/planning/" + id, params).then((res) => {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Update status"
            }))
            this.getEstates();
        })
    }

    updateEstate(id, obj, type, sendEmail = false) {
        const params = {
            email: obj.email,
            first_name: obj.first_name,
            last_name: obj.last_name,
            name: obj.name,
            notes: obj.note,
            content: obj.content,
            type
        }
        instance.put(BASE_URL + "tool/estate/planning/" + id, params).then((res) => {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Update successfully"
            }))
            if (sendEmail) {
                this.sendEmail(id);
            } else {
                this.getEstates();
                this.closeDialog();
            }
            ;
        })
    }

    updateEstateDOS(dos, callback = null) {
        const {dialogData} = this.state;
        const params = {
            dos,
        }
        instance.put(BASE_URL + "tool/estate/planning/" + dialogData.id, params).then((res) => {
            if (callback) callback();
        })
    }

    delEstate(id) {
        instance.delete(BASE_URL + "tool/estate/planning/" + id).then((res) => {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Delete successfully"
            }))
            this.getEstates();
        })
    }

    download(id, status) {
        let url = "";
        if (status === "final") {
            url = BASE_URL + "tool/estate/planning/" + id + "/download/final";
        } else if (status === "draft") {
            url = BASE_URL + "tool/estate/planning/" + id + "/download/draft";
        } else {
            return;
        }
        instance.get(url).then((res) => {
            this.loopGetDownloadUrl(id, status);
            this.setState(() => ({
                showAlertFile: true,
                dialogContent: "The file is being generated and will be automatically downloaded after the generation is completed. The entire process is expected to take about 10 seconds, please be patient...",
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "Start generating files..."
            }))
        })
    }

    loopGetDownloadUrl(id, status) {
        this.epPolling(id, (obj) => {
            let src = "";
            if (obj.task_status === "SUCCESS") {
                src = (status === "final") ? obj.final_url : obj.draft_url;
                this.setState(() => ({
                    toastTime: 3000,
                    showAlertFile: false,
                    showToast: true,
                    toastState: "success",
                    toastTitle: "Generated successfully, ready to download..."
                }))
                console.log(src)
                this.downloadFile(src);
            } else if (obj.task_status === "FAILURE") {
                this.setState(() => ({
                    toastTime: 3000,
                    showAlertFile: false,
                    showToast: true,
                    toastState: "error",
                    toastTitle: "Failed to get status, please try again"
                }))
            } else if (obj.task_status === "PENDING") {
                setTimeout(() => {
                    this.loopGetDownloadUrl(id, status);
                }, 1000);
            }
        });
    }

    downloadFile(src) {
        const a = document.createElement('a');
        a.href = src;
        a.click();
    }

    uploadFile(file, dos) {
        const {dialogData} = this.state;
        const data = new FormData();
        console.log(file)
        data.append('file', file);
        axios({
            url: BASE_URL + "tool/estate/planning/" + dialogData.id + "/upload/template",
            method: "post",
            data,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": "Bearer " + window.localStorage.getItem("token")
            },
            onUploadProgress: this.onUploadProgress
        }).then(res => {
            if (res.data.error === 0) {
                this.loopGetStatus(dialogData.id, dos);
            }
        }).catch(err => {
            this.setState(() => ({
                openProgress: false,
                toastTime: 3000,
                showToast: true,
                toastState: "error",
                toastTitle: "Upload failed"
            }));
        })
    }

    loopGetStatus(id, dos) {
        this.getEPInfo(id, (obj) => {
            let status = obj.status;
            if (status === "final") {
                this.setState(() => ({
                    showAlertFile: false,
                    progress: 0,
                    toastTime: 3000,
                    showToast: true,
                    toastState: "success",
                    toastTitle: "Successfully uploaded"
                }));
                this.updateEstateDOS(dos, () => {
                    this.getEstates();
                });
            } else {
                setTimeout(() => {
                    this.loopGetStatus(id, dos);
                }, 1000);
            }
        });
    }

    onUploadProgress(progressEvent) {
        let progress = (progressEvent.loaded / progressEvent.total * 100 | 0)
        if (progress >= 100) {
            this.setState(() => ({
                progress,
                openProgress: false,
                showAlertFile: true,
                dialogContent: "The upload is complete, the status is being updated, please wait...",
            }))
        } else {
            this.setState(() => ({
                progress
            }))
        }
    }
}

export default withRouter(ToolEstate);